module.exports = __webpack_public_path__ + "static/img/autCt_bg_06.09322213.svg";